import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_1162 implements Validator {

    public static id = 'CTRL_1162';
    private message = 'error.ctr_1162';


    public LOG: LogService = new LogService(CTRL_1162);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_1162.id + '_');

        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const criterePCT = ctrl.value.rgCtrls.criterePCT;
                const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
                const criterePondereIters = this.formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepSep_CriterePondere'], '_index_');
                
                let sumCriterePCT = 0;
                for (let i = 1; i <= criterePondereIters.size; i++) {
                    const criterePCTCtrl = form.controls[map.get(criterePCT.replace('INDEX_1162_1', i))];
                    if (criterePCTCtrl.value !== '' && criterePCTCtrl.value !== null) {
                        sumCriterePCT += Math.max(criterePCTCtrl.value, 1);
                    }
                }
                if (sumCriterePCT == 100) {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                } else {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                }
                
            }
        }
    }
}
